/**
 *
 * MerchantGroup Selectors
 *
 */

import { createSelector } from 'reselect';

const getMerchantGroupRoot = state => state.merchantGroup;

export const getMerchantGroup = createSelector(
  getMerchantGroupRoot,
  merchantGroup =>
    merchantGroup && merchantGroup.data && merchantGroup.data.merchantDTOList,
);

export const getMerchantGroupByCity = createSelector(
  getMerchantGroup,
  merchantGroup =>
    merchantGroup &&
    merchantGroup.reduce(
      (cityGrouping, merchant) => ({
        ...cityGrouping,
        [merchant.address.city]: [
          ...(cityGrouping[merchant.address.city] || []),
          merchant,
        ],
      }),
      {},
    ),
);

export const getMerchantGroupFailure = createSelector(
  getMerchantGroupRoot,
  merchantGroup => merchantGroup && merchantGroup.error,
);

export const getMerchantGroupTheme = createSelector(
  getMerchantGroupRoot,
  merchantGroup =>
    (merchantGroup && merchantGroup.data && merchantGroup.data.theme) || {},
);
